import "./App.css";
import "./css/pages/LoginPage.css";
import "./css/pages/Dashboard.css";
import "./css/pages/AllAdmin.css";
import "./css/components/LogOutAlert.css";
import "./css/components/CreateUserPopup.css";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import AdminRoute from "./routes/AdminRoute";
import UserRoute from "./routes/UserRoute";

const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/admin/*" element={<AdminRoute />} />
          <Route path="/dashboard/*" element={<UserRoute />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
